import React, { useState, Suspense, lazy, useTransition, useLayoutEffect } from "react";
import { NavigationBar } from "./components";
import Loader from "./components/Loader/Loader";

const Home = lazy(() => import("./pages/Home/Home"));
const Projects = lazy(() => import("./pages/Projects/Projects"));
const Experience = lazy(() => import("./pages/Experience/Experience"));
const Involvements = lazy(() => import("./pages/Involvements/Involvements"));
const TechStack = lazy(() => import("./pages/TechStack/TechStack"));
const NotFound = lazy(() => import("./pages/NotFound/NotFound"));

const App = () => {
  const [currentTab, setCurrentTab] = useState("home");
  const [isPending, startTransition] = useTransition();

  // Reset scroll position SYNC on tab change to prevent 1-frame scroll flicker
  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [currentTab]);

  const handleTabChange = (key) => {
    startTransition(() => {
      setCurrentTab(key);
    });
  };

  const renderComponent = (tab) => {
    switch (tab) {
      case "home":
        return <Home />;
      case "projects":
        return <Projects />;
      case "experience":
        return <Experience />;
      case "involvements":
        return <Involvements />;
      case "techstack":
        return <TechStack />;
      default:
        return <NotFound />;
    }
  };

  return (
    <div className="App">
      <NavigationBar
        currentTab={currentTab}
        setCurrentTab={handleTabChange}
        isPending={isPending}
      />
      <div style={{ paddingTop: "75px" }}>
        <Suspense fallback={<Loader />}>{renderComponent(currentTab)}</Suspense>
      </div>
    </div>
  );
};

export default App;
